export enum StudyReviewsType {
  SUMMARY_REPORT = 'summary_report',
  FULL_REPORT = 'full_report',
  PUBLIC_CONSULTATION = 'public_consultation',
  COMMENTS_OVERVIEW = 'comments_overview',
  TECHNICAL_REPORT = 'technical_report',
  DECISIONS = 'decisions',
  QUESTIONNAIRE = 'questionnaire',
}
